import type { PhantomType } from '@moojo/phantom-type'
import { z } from 'zod'

/**
 * The ID of a user in a social network.
 */
export type ProfileId = PhantomType<string, 'ProfileId'>
export const ProfileId = {
  make,
  unmake,
  zod: z.string().transform(s => fromObject(unmake(s as ProfileId))),
}

type SocialNetwork =
  /**
   * an open ID value provided by Tiktok
   */
  'tiktokOpenId'

function make(socialNetwork: SocialNetwork, value: string) {
  return fromObject({ socialNetwork, value })
}

function fromObject(input: { socialNetwork: SocialNetwork; value: string }) {
  let value = input.value
  value = value.trim()
  if (!value) {
    throw new Error(`empty value cannot be used as ProfileId`)
  }
  const abbreviation = abbreviations[input.socialNetwork]
  return `${abbreviation}:${value}` as ProfileId
}

function unmake(profileId: ProfileId) {
  const parts = profileId.split(':')
  if (parts.length !== 2) {
    throw new Error(`Bad ProfileId value ("${profileId}")`)
  }

  const network = networkByAbbreviation.get(parts[0])
  if (!network) {
    throw new Error(`unrecognized abbreviation: ${parts[0]}`)
  }

  return { socialNetwork: network, value: parts[1] }
}

const abbreviations: Record<SocialNetwork, string> = {
  tiktokOpenId: 'TT',
}

const networkByAbbreviation = new Map<string, SocialNetwork>(
  Object.entries(abbreviations).map(([k, v]) => [v, k as SocialNetwork]),
)
